<template>
  <b-modal
    centered
    ref="editPart"
    id="editPart"
    body-class="modal-body-wo"
    hide-footer
    hide-header
    size="wisde"
    title="Edit Part"
    :no-enforce-focus="true"
    @hidden="modalClosed"
    :no-close-on-backdrop="true"
  >
    <div class="p-4">
      <div class="font-weight-bold">Add part to request</div>
      <ValidationObserver tag="form" ref="form" @submit.stop.prevent="savePart" v-slot="{ invalid }" class="">
        <div class="row">
          <div class="col-6">
            <ValidationProvider name="PN" rules="required" v-slot="{ errors }">
              <div class="label mt-2">PN</div>
              <input :disabled="part.isReadonly" type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" placeholder="PN of the Part" v-model="part.pn" />
            </ValidationProvider>
          </div>

          <div class="col-6">
            <div class="label mt-2">Alt PN</div>
            <input type="text" class="form-control" placeholder="Alternative PN of the Part" v-model="part.altPn" :disabled="part.isReadonly"/>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="label mt-2">IPC</div>
            <input type="text" class="form-control" placeholder="IPC of the Part" v-model="part.ipc" :disabled="part.isReadonly"/>
          </div>

          <div class="col-6">
            <div class="label mt-2">Alt IPC</div>
            <input type="text" class="form-control" placeholder="Alternative IPC of the Part" v-model="part.altIpc" :disabled="part.isReadonly"/>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <ValidationProvider name="PartDescription" rules="required" v-slot="{ errors }">
              <div class="label mt-2">Part description</div>
              <input type="text" class="form-control" placeholder="Part description" :class="{ 'is-invalid': errors[0] }" v-model="part.description" />
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <ValidationProvider name="Quantity" rules="required" v-slot="{ errors }">
            <div class="label mt-2">Quantity</div>
            <input type="number" class="form-control" placeholder="Quantity needed" :class="{ 'is-invalid': errors[0] }" v-model="part.quantityRequested" />
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="label mt-2">Remark</div>
            <textarea rows="4" class="form-control" placeholder="optional remark" v-model="part.remark" />
          </div>
        </div>


        <div class="row" v-if="partId !== '00000000-0000-0000-0000-000000000000'">
          <div class="col-12">
            <div class="label mt-3 d-flex justify-content-between">
              <div>Attachments</div>
              <div>
                <UploadAttachment :isSmallButton="true" :label="'Add Attachment'" :destination="'MaterialPart'" :destinationId="part.id" @uploaded="loadAttachments" />
              </div>
            </div>
            <AttachmentView @deleted="loadAttachments" :header="''" :destinationId="part.id" :destination="'MaterialPart'" :attachments="attachments" />
          </div>
        </div>

        <hr />

        <div class="mt-3 d-flex justify-content-between align-content-center">
          <div class="so-btn">
            <button type="button" class="btn btn-block btn-sm btn-secondary" @click="cancel()">
              <i class="far fa-times"></i>
              Cancel
            </button>
          </div>
          <div class="so-btn">
            <button type="submit" class="btn btn-block btn-sm btn-success" :disabled="invalid">
              <i class="far fa-save"></i>
              Save changes
            </button>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </b-modal>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { attachmentClient, materialRequestClient } from "@/apiclient/opsboardapi";
  import { AttachmentDestination, AttachmentDto, PartDto } from "@/apiclient/apiclient_generated";
  import RouteNames from '@/types/routeNames';
  import { GlobalHelper } from '@/helpers/global-helper';
  import UploadAttachment from "@/components/Attachments/UploadAttachment.vue";
  import AttachmentView from "@/components/Attachments/AttachmentView.vue";

  @Component({
    components: { AttachmentView, UploadAttachment },
  })
  export default class EditPart extends Vue {
    materialRequestId: string;
    partId: string;
    part: PartDto = PartDto.fromJS({});
    attachments: AttachmentDto[] = [];

    created() {
      this.materialRequestId = this.$router.currentRoute.params.materialRequestId;
      this.partId = this.$router.currentRoute.params.partId;
    }

    async mounted() {
      this.$bvModal.show('editPart');
      await this.loadData();
    }

    async loadData() {
      if (this.partId == '0') this.partId = '00000000-0000-0000-0000-000000000000';

      this.part = await materialRequestClient.getPartEditDto(this.materialRequestId, this.partId);
      await this.loadAttachments();
      await this.$nextTick();
      (this.$refs.form as any).validate();
    }

    async loadAttachments() {
      this.attachments = await attachmentClient.getAllAttachments(this.part.id, AttachmentDestination.MaterialPart);
    }

    async savePart() {
      try {
        await materialRequestClient.editPart(this.part);
        GlobalHelper.NotifySuccess('Part saved');
        this.$bvModal.hide('editPart');
      } catch {
        GlobalHelper.NotifyError('Error occured');
      }
    }

    cancel() {
      this.$bvModal.hide('editPart');
    }

    modalClosed() {
      this.$router.push({ name: RouteNames.specialOccurrence.root, params: { occId: this.materialRequestId } });
    }
  }
</script>

<style lang="scss" scoped></style>
